<template>
  <path
    d="M9 5.50024C9 6.33024 9.67 7.00024 10.5 7.00024H14V17.5002C14 18.3302 14.67 19.0002 15.5 19.0002C16.33 19.0002 17 18.3302 17 17.5002V7.00024H20.5C21.33 7.00024 22 6.33024 22 5.50024C22 4.67024 21.33 4.00024 20.5 4.00024H10.5C9.67 4.00024 9 4.67024 9 5.50024ZM4.5 12.0002H6V17.5002C6 18.3302 6.67 19.0002 7.5 19.0002C8.33 19.0002 9 18.3302 9 17.5002V12.0002H10.5C11.33 12.0002 12 11.3302 12 10.5002C12 9.67024 11.33 9.00024 10.5 9.00024H4.5C3.67 9.00024 3 9.67024 3 10.5002C3 11.3302 3.67 12.0002 4.5 12.0002Z"
  />
</template>
